import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export type ListEventsParams = NonNullable<
	Api.Operations['listEvents']['parameters']
>['query']

export interface ListEvents {
	params?: NonNullable<Api.Operations['listEvents']['parameters']>['query']
	response: Api.Operations['listEvents']['responses']['200']['content']['application/json']
}

export const listEvents = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<ListEvents>(
		{
			method: 'get',
			url: '/events',
			...overideConfig,
		},
		axiosInstance,
	)
